<template>
  <div class="circleHeight">
    <div v-if="showQuota">
      <van-row class="circleTitle">
        <van-col>{{showQuota.name}}</van-col>
        <van-col @click="infoClick" style="margin-left:7px;" v-show="showQuota.indexParaphrase != ''">
          <img style="width: 21px; height: 21px;" alt="指标释义" src="../../../../static/images/info.png">
        </van-col>
        <van-col :style="{float:'right'}">
          <div @click="handelDetailClick" >
            <img src="../../../../static/images/more.png" style="width:.1rem;height:.16rem">
          </div>
        </van-col>
      </van-row>
      <div @click="handelDetailClick">
        <!-- 导入指标 -->
        <van-row type="flex" v-if="showQuota.classification === 5">
          <van-col span="24">
            <div class="circle one">
              <p :style="{marginTop: '.01rem'}">
                <label>{{showQuota.achievementRateName}}</label><span>{{showQuota.achievementRate}}</span>{{showQuota.unit}}
              </p>
            </div>
          </van-col>
        </van-row>
        <!-- 应用指标 -->
        <van-row type="flex" v-else>
          <van-col span="16">
            <div class="circle">
              <p :style="{marginTop: '.01rem'}">
                <label>当年</label><span>{{showQuota.year}}</span>{{showQuota.yearUnit}}
              </p>
              <p>
                <label>当月</label><span>{{showQuota.month}}</span>{{showQuota.monthUnit}}
              </p>
            </div>
          </van-col>
          <van-col span="8" v-show="showFlag && showFlag.hasAchievementRate">
            <van-circle
              :clockwise="dirFlagA"
              :rate="showQuota.achievementRate"
              :speed="100"
              :stroke-width="70"
              :style="{marginTop: '.01rem',width:'100%'}"
              :text="textA"
              :color="rateColorTwo"
              fill="#fff"
              layer-color="#ebedf0"
              size="60%"
              v-model="currentRateA"
            />
            <span class="van-circle-title">{{showQuota.achievementRateName}}</span>
          </van-col>
          <van-col span="8">
            <van-circle
              :clockwise="dirFlagB"
              :rate="showQuota.onYearRate"
              :speed="100"
              :stroke-width="70"
              :style="{marginTop: '.01rem',width:'100%'}"
              :text="textB"
              :color="rateColor"
              fill="#fff"
              layer-color="#ebedf0"
              size="60%"
              v-model="currentRateB"
            />
          <span class="van-circle-title">年同比</span>
          </van-col>
        </van-row>
      </div>
      <van-row class="circleFooter" type="flex">
        <van-col span="6">{{showQuota.orgName}}</van-col>
        <van-col :style="{textAlign:'right'}" span="18">统计时间：{{showQuota.yearTime}}</van-col>
      </van-row>
    </div>
    <infoDialog :show="show" :indexParaphrase="indexParaphrase" @confirm="confirm" />
  </div>
</template>

<script>
import { getAction } from '@/utils/api'
import infoDialog from '@/pages/common/infoDialog'
export default {
  name: 'EntiretyCard',
  data () {
    return {
      flag: true,
      currentRateA: 0,
      currentRateB: 0,
      rate: 0,
      onYearV: 0,
      date: '',
      postpath: '',
      dataurl: '',
      delurl: '',
      posturl: '',
      typeData: null,
      dirFlagA: true,
      dirFlagB: true,
      rateColor: '#3399FF',
      rateColorTwo: '#3399FF',
      textA: '0',
      textB: '0',
      rateFlag: false,
      showQuota: {},
      showFlag: {},
      show: false,
      indexParaphrase: ''
    }
  },
  components: {
    infoDialog
  },
  props: {quotaCard: {
    type: Object,
    require: true
  }},
  methods: {
    infoClick () {
      this.show = true
      this.indexParaphrase = this.showQuota.indexParaphrase
    },
    confirm () {
      this.show = false
    },
    getNowDate () {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1 < 10 ? '0' + date.getMonth() + 1 : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      var nowDate = '' + year + month + day + hour + minute + second
      return nowDate
    },
    //  跳转详情页面
    handelDetailClick () {
      this.$store.commit('ENTIRETY_SET_PAGEFLAG', 2)
      localStorage.setItem('pageFlag', 2)
      // 渠道数据存储
      this.$store.commit('ENTIRETY_SET_CHANNEL', this.showQuota.channlId)
      this.$store.commit('ENTIRETY_SET_CHANNEL_NAME', this.showQuota.channlName)
      sessionStorage.setItem('fromType', '1')
      this.$router.push({
        path: '/entiretyDetail',
        query: {indexId: this.$store.state.entirety.quota, moduleId: this.$store.state.user.pageCode, channelId: this.$store.state.entirety.channel, channelName: this.$store.state.entirety.channelName, time: this.$store.state.entirety.time, kind: this.$store.state.entirety.kind, level: this.$store.state.user.level, orgId: this.$store.state.user.orgId, areaFlag: this.$store.state.user.areaFlag, type: this.$store.state.entirety.type, tm: this.$route.query.tm}
      })
    },
    getCurShow () {
      var getPostdata = {
        moduleId: this.$store.state.user.pageCode,
        indexId: this.$store.state.entirety.quota,
        channelId: this.$store.state.entirety.channel,
        date: ''
      }
      var getFlag = getAction('/performance/dimension/showDimension', getPostdata)
      getFlag.then(res => {
        this.showFlag = res.data
      })
    }
  },
  computed: {
    getQuota () {
      return this.$store.state.entirety.quota
    }
  },
  watch: {
    quotaCard () {
      this.$nextTick(() => {
        this.showQuota = {}
        Object.assign(this.showQuota, this.quotaCard)
        if (this.$store.state.entirety.channel) {
          this.getCurShow()
        }
        //  判断返回的年月值为null显示--
        if (this.showQuota.year === null) {
          this.showQuota.year = '--'
        }
        if (this.showQuota.month === null) {
          this.showQuota.month = '--'
        }
        // 如果达成率返回null或者--
        // achievementRate 达成率，achievementRateUnit 达成率单位
        // onYearRate 同比，onYearRateUnit 同比单位
        // 导入指标
        if (this.showQuota.classification === 5) {
          // 实际值空值处理
          if (this.showQuota.achievementRate === null || this.showQuota.achievementRate === '--') {
            this.showQuota.achievementRate = '--'
          }
        } else {
          // 应用指标
          if (this.showQuota.achievementRate === null || this.showQuota.achievementRate === '--') {
            this.textA = '--' + this.showQuota.achievementRateUnit
            this.showQuota.achievementRate = 0
            this.rateColorTwo = '#ebedf0'
          } else if (this.showQuota.achievementRate === 0) {
            this.textA = '0' + this.showQuota.achievementRateUnit
            this.rateColorTwo = '#ebedf0'
          } else {
            // 如果是负值
            if (this.showQuota.achievementRate < 0) {
              this.showQuota.achievementRate = -this.showQuota.achievementRate
              this.dirFlagA = false
              this.rateColorTwo = '#999'
              this.textA = '-' + this.showQuota.achievementRate.toFixed(0) + this.showQuota.achievementRateUnit
            } else {
              this.dirFlagA = true
              this.textA = this.showQuota.achievementRate.toFixed(0) + this.showQuota.achievementRateUnit
              this.rateColorTwo = '#3399FF'
            }
          }
        }
        // 如果年同比返回null或者--
        if (this.showQuota.onYearRate === null || this.showQuota.onYearRate === '--') {
          this.textB = '--' + this.showQuota.onYearRateUnit
          this.rateColor = '#ebedf0'
          this.showQuota.onYearRate = 0
        } else if (this.showQuota.onYearRate === 0) {
          this.textB = '0' + this.showQuota.onYearRateUnit
          this.rateColor = '#ebedf0'
        } else {
          // 如果年同比是负值的时候
          if (this.showQuota.onYearRate < 0) {
            this.showQuota.onYearRate = -this.showQuota.onYearRate
            this.dirFlagB = false
            this.rateColor = '#999'
            this.textB = '-' + this.showQuota.onYearRate.toFixed(0) + this.showQuota.onYearRateUnit
          } else {
            this.dirFlagB = true
            this.rateColor = '#3399FF'
            this.showQuota.onYearRate = this.showQuota.onYearRate
            this.textB = this.showQuota.onYearRate.toFixed(0) + this.showQuota.onYearRateUnit
          }
        }
      })
    },
    show (val) {
      if (val) {
        this.$emit('getFlag1', true)
      } else {
        this.$emit('getFlag1', false)
      }
    }
  },
  mounted () {
    if (this.$store.state.entirety.channel) {
      this.getCurShow()
    }
  }
}
</script>

<style lang="stylus" scoped>
.circle {
  p {
    color: #333;
    font-size: 0.12rem;
    line-height: 2;

    span {
      display: inline-block;
      margin: 0px 5px;
      font-size: 0.18rem;
      font-family: 'numberfont'
    }
  }
}

.circle label{
  font-weight:normal;
  font-size:0.14rem;
}

.circleHeight {
  min-height:1.52rem
  margin-top: 0.1rem;
  padding: 0px 15px 15px 15px;
  background: #fff;
}

.circleTitle {
  font-size: 0.18rem;
  font-weight: 600;
  height: 0.45rem;
  line-height: 0.45rem;
}

.circleTitle div:last-child {
  text-align: right;
  padding-left : .04rem;
}

.circleFooter {
  font-size: 0.12rem;
  color: #BDBDBD;
}

.circleHeight>>>.van-circle svg {
  transform: rotate(-90deg);
}

.circleHeight>>>.van-circle__text{
  font-size: 0.15rem;
  font-weight: 600;
}
.van-col.van-col--8{
  text-align : center;
}
.van-circle-title{
  font-size : 0.10rem;
  display: inherit;
  color: #BDBDBD;
}
.one {
  height: 59px;
  margin-top:0.2rem;
  display:flex;
  justify-content:center;
}
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/EntiretyCard.vue